// Smooth scroll
$('.sub-menu a[href^="#"]').click(function(e) {
    e.preventDefault();

    var el = document.querySelector(this.getAttribute("href"));
    var scrollLoc;

    if ($(this).hasClass("goMain")) {
        scrollLoc = getScrollPos(el, "header");
    } else {
        scrollLoc = getScrollPos(el, ".sub-menu");
    }

    scrollTo(scrollLoc, 800);
});

$(function() {
    var lastScrollTop = 0;
    var offset = $('[class*="promotion-section"]').position().top - 80;

    // Sub Navigation
    $(window).on("scroll", function(e) {
        scrollSpy();
        if ($(window).scrollTop() >= offset) {
            $("header").removeClass("animated");
            $(".sub-menu").addClass("active");
        } else {
            $("header").addClass("animated");
            $(".sub-menu").removeClass("active");
        }

        var st = $(this).scrollTop();
        // if (st > lastScrollTop){
        //     // downscroll code
        //     $('.nav-select-container').removeClass('active');
        // } else {
        //    // upscroll code
        //    $('.nav-select-container').addClass('active');
        // }
        lastScrollTop = st;
    });

    // Sub nav mobile
    $(".nav-select").change(function() {
        var target = $(this).val();
        var element = document.querySelector(target);

        scrollLoc = getScrollPos(element, ".sub-menu");

        if (target == "#nav-promotion") {
            scrollLoc += 35;
        }

        scrollTo(scrollLoc, 800);
    });
    // });

    //show-hide grade detail popup
    // $(function() {

    function show_grade_detail_popup(grade, detail, price, imgdesktop, imgmobile) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#grade_detail_fade_all").fadeIn(780);

        $("#grade_detail_popup_all").scrollTop(0);

        $("#grade_detail_popup_all").addClass("active");
        initMainHeading("#grade_detail_popup_all .main-heading");
        $("#grade_detail_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        $("#grade_detail_popup_all").addClass("active_pos");

        $(".show-grade-detail").css({ opacity: 0 });

        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#grade_detail_popup_all .header_grade_detail").addClass("header_gradse_detail_pos");

            let fullpath = $(".popup_show_img_pc").data("src");

            if (imgdesktop != "undefined") {
                $("#grade_detail_popup_all .popup_show_img_pc").attr("src", fullpath + "/" + imgdesktop);
            }
            if (imgmobile != "undefined") {
                $("#grade_detail_popup_all .popup_show_img_mobile").attr("src", fullpath + "/" + imgmobile);
            }
            if (grade != "undefined") {
                let str_html = grade + "<br>" + price + "";
                $("#grade_detail_popup_all .popup_detail_content_title").html(str_html);
            }
            if (detail != "undefined") {
                $("#grade_detail_popup_all .popup_detail_content_desc").html(detail);
            }

            $(".show-grade-detail").css({ opacity: 1 });
            if ($(window).width() <= 768) {
                $("#grade_detail_popup_all .header_grade_detail").addClass("bartop");
            }
        }, 1000);
    }

    function close_grade_detail_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#grade_detail_popup_all").addClass("active_pos_fixed");
        if ($(window).width() <= 768) {
            $("#grade_detail_popup_all .header_grade_detail").removeClass("bartop");
        }
        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-grade").offset().top - 0
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#grade_detail_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            // $('#grade_detail_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
            $("#grade_detail_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
        }, 800);

        setTimeout(function() {
            $("#grade_detail_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#grade_detail_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_grade_detail_popup();
    });

    $(".btn_grade_pop_show").on("click", function(e) {
        e.preventDefault();
        //   setDataGradeDetail();
        $("#grade_detail_popup_all .grade_detail_tab_block").show();
        $("#grade_detail_popup_all .show-grade-detail").hide();
        show_grade_detail_popup($(this).data("gradebtnpopup"));
    });
    //   $( ".btn_grade_pop_show_more" ).on( "click", function(e) {
    //       e.preventDefault();
    //       $("#grade_detail_popup_all .grade_detail_tab_block").hide();
    //       $("#grade_detail_popup_all .show-grade-detail").show();

    //       let nameTag = $(this).data('gradebtnpopup');
    //       let deatail = $(this).data('gradedetail');
    //       let price = $(this).data('price');
    //       let imgdesktop = $(this).data('imagedesktop');
    //       let imgmobile = $(this).data('imagemobile');
    //       show_grade_detail_popup(nameTag,deatail,price,imgdesktop,imgmobile);
    //   });

    $("body").on("click", ".btn_grade_pop_show_more", function(e) {
        e.preventDefault();
        $("#grade_detail_popup_all .grade_detail_tab_block").hide();
        $("#grade_detail_popup_all .show-grade-detail").show();

        let nameTag = $(this).data("gradebtnpopup");
        let deatail = $(this).data("gradedetail");
        let price = $(this).data("price");
        let imgdesktop = $(this).data("imagedesktop");
        let imgmobile = $(this).data("imagemobile");
        show_grade_detail_popup(nameTag, deatail, price, imgdesktop, imgmobile);
    });

    // $('.btn_grade_pop_show').click(function(e) {
    //     e.preventDefault();
    //     show_grade_detail_popup($(this).data('gradebtnpopup'));
    // });

    // });

    //show-hide popup_performance
    // $(function() {

    function show_performance_popup(tabId, index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_performance_fade_all").fadeIn(780);

        $("#popup_performance_popup_all").css("visibility", "hidden");
        $("#popup_performance_popup_all").scrollTop(0);

        $("#popup_performance_popup_all .grade_detail_box").hide();
        $("#popup_performance_popup_all #performance-box-" + tabId).show();

        $("#popup_performance_popup_all").addClass("active");
        initMainHeading("#popup_performance_popup_all .main-heading");
        $("#popup_performance_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");
        var offset_top = $("#popup_performance_popup_all #performance-box-" + tabId + " .popup_detail_holder > div")
            .eq(index)
            .offset().top;
        $("#popup_performance_popup_all").css("visibility", "visible");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        $("#popup_performance_popup_all").addClass("active_pos");
        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#popup_performance_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // setTimeout(function () {
        //   $('#popup_performance_popup_all').addClass('active');
        //   initMainHeading('#popup_performance_popup_all .main-heading');
        //   $('#popup_performance_popup_all .header_grade_detail').addClass('animated_header');
        //   $('body').addClass('prevent-scroll');

        // var offset_top = $("#popup_performance_popup_all #performance-box-" + tabId + " .popup_detail_holder > div").eq(index).offset().top;
        // // $("#popup_performance_popup_all").scrollTop( offset_top - 95 );
        // $("#popup_performance_popup_all").css('visibility','visible');

        // setTimeout(function () {
        //     $('#popup_performance_popup_all .header_grade_detail').addClass('animated_header');

        // setTimeout(function () {
        //     $('#popup_performance_popup_all').addClass('active_pos');

        //     setTimeout(function () {
        //       $('body').removeClass('prevent-scroll');
        //       $('#popup_performance_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //     },800);

        // }, 1500);

        //     $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        //     $('body').addClass('grade_body');
        // }, 1200);

        // }, 1000);
    }

    function close_performance_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_performance_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-performance").offset().top - 56
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_performance_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            $("#popup_performance_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
            // $('#popup_performance_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
        }, 800);

        setTimeout(function() {
            $("#popup_performance_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_performance_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_performance_popup();
    });

    $(".performance").on("click", ".btn_performance_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_performance_popup($(this).data("tab-id"), _index);
    });

    // });

    //show-hide popup_sensing
    // $(function() {

    function show_sensing_popup(tabId, index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_sensing_fade_all").fadeIn(780);

        $("#popup_highlight_popup_all").css("visibility", "hidden");
        $("#popup_highlight_popup_all").scrollTop(0);

        $("#popup_sensing_popup_all .grade_detail_box").hide();
        $("#popup_sensing_popup_all #sensing-box-" + tabId).show();

        $("#popup_sensing_popup_all").addClass("active");
        initMainHeading("#popup_sensing_popup_all .main-heading");
        $("#popup_sensing_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");

        var offset_top = $("#popup_sensing_popup_all #sensing-box-" + tabId + " .popup_detail_holder > div")
            .eq(index)
            .offset().top;
        $("#popup_sensing_popup_all").css("visibility", "visible");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        $("#popup_sensing_popup_all").addClass("active_pos");
        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#popup_sensing_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // $('.sub-menu').addClass('sub-menu-hide');
        // $('header:not(.header_grade_detail)').hide();
        // $('#popup_sensing_fade_all').fadeIn(780);

        // $("#popup_highlight_popup_all").css('visibility','hidden');
        // $("#popup_highlight_popup_all").scrollTop( 0 );

        // $('#popup_sensing_popup_all .grade_detail_box').hide();
        // $('#popup_sensing_popup_all #sensing-box-' + tabId).show();

        // setTimeout(function () {
        //   $('#popup_sensing_popup_all').addClass('active');
        //   initMainHeading('#popup_sensing_popup_all .main-heading');
        //   $('#popup_sensing_popup_all .header_grade_detail').addClass('animated_header');
        //   $('body').addClass('prevent-scroll');

        // var offset_top = $("#popup_sensing_popup_all #sensing-box-" + tabId + " .popup_detail_holder > div").eq(index).offset().top;
        // // $("#popup_sensing_popup_all").scrollTop( offset_top - 95 );
        // $("#popup_sensing_popup_all").css('visibility','visible');

        // setTimeout(function () {
        // $('#popup_sensing_popup_all .header_grade_detail').addClass('animated_header');

        // setTimeout(function () {
        //     $('#popup_sensing_popup_all').addClass('active_pos');

        //     setTimeout(function () {
        //       $('body').removeClass('prevent-scroll');
        //       $('#popup_sensing_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //     },800);

        // }, 1500);

        // $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        // $('body').addClass('grade_body');
        // }, 1200);

        // }, 1000);
    }

    function close_sensing_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_sensing_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-smart-spot").offset().top - 0
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_sensing_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            // $('#popup_sensing_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
            $("#popup_sensing_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
        }, 800);

        setTimeout(function() {
            $("#popup_sensing_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_sensing_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_sensing_popup();
    });

    $(".smart-spot").on("click", ".btn_smartspot_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_sensing_popup($(this).data("tab-id"), _index);
    });

    // });

    //show-hide popup_design
    // $(function() {
    function show_design_popup(tabId, index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_design_fade_all").fadeIn(780);

        $("#popup_highlight_popup_all").css("visibility", "hidden");
        $("#popup_highlight_popup_all").scrollTop(0);

        $("#popup_design_popup_all .grade_detail_box").hide();
        $("#popup_design_popup_all #design-box-" + tabId).show();

        // (function () {
        $("#popup_design_popup_all").addClass("active");
        initMainHeading("#popup_design_popup_all .main-heading");
        $("#popup_design_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");

        // var offset_top = $("#popup_design_popup_all #design-box-" + tabId + " .popup_detail_holder > div").eq(index).offset().top;
        // $("#popup_design_popup_all").scrollTop( offset_top - 95 );
        $("#popup_design_popup_all").css("visibility", "visible");
        $("#popup_design_popup_all .header_grade_detail").addClass("animated_header");
        $("#popup_design_popup_all").addClass("active_pos");
        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#popup_design_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // setTimeout(function () {
        //   $('#popup_design_popup_all').addClass('active');
        //   initMainHeading('#popup_design_popup_all .main-heading');
        //   $('#popup_design_popup_all .header_grade_detail').addClass('animated_header');
        //   $('body').addClass('prevent-scroll');

        //   // var offset_top = $("#popup_design_popup_all #design-box-" + tabId + " .popup_detail_holder > div").eq(index).offset().top;
        //   // $("#popup_design_popup_all").scrollTop( offset_top - 95 );
        //   $("#popup_design_popup_all").css('visibility','visible');

        //   // setTimeout(function () {
        //       $('#popup_design_popup_all .header_grade_detail').addClass('animated_header');

        //       // setTimeout(function () {
        //           $('#popup_design_popup_all').addClass('active_pos');

        //           // setTimeout(function () {
        //             $('body').removeClass('prevent-scroll');
        //             $('#popup_design_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //           // },800);

        //       // }, 1500);

        //       $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        //       $('body').addClass('grade_body');
        //   // }, 1200);

        // }, 1000);
    }

    function close_design_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_design_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-design").offset().top - 0
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_design_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            // $('#popup_design_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
            $("#popup_design_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
        }, 800);

        setTimeout(function() {
            $("#popup_design_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_design_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_design_popup();
    });

    $(".design-section").on("click", ".btn_design_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_design_popup($(this).data("tab-id"), _index);
    });

    // });

    //show-hide popup_feature
    // $(function() {
    function show_feature_popup(tabId, index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_feature_fade_all").fadeIn(780);

        $("#popup_highlight_popup_all").css("visibility", "hidden");
        $("#popup_highlight_popup_all").scrollTop(0);

        $("#popup_feature_popup_all .grade_detail_box").hide();
        $("#popup_feature_popup_all #feature-box-" + tabId).show();

        setTimeout(function() {
            $("#popup_feature_popup_all").addClass("active");
            initMainHeading("#popup_feature_popup_all .main-heading");
            $("#popup_feature_popup_all .header_grade_detail").addClass("animated_header");
            $("body").addClass("prevent-scroll");

            var offset_top = $("#popup_feature_popup_all #feature-box-" + tabId + " .popup_detail_holder > div")
                .eq(index)
                .offset().top;
            $("#popup_feature_popup_all").scrollTop(offset_top - 95);
            $("#popup_feature_popup_all").css("visibility", "visible");

            setTimeout(function() {
                $("#popup_feature_popup_all .header_grade_detail").addClass("animated_header");

                setTimeout(function() {
                    $("#popup_feature_popup_all").addClass("active_pos");

                    setTimeout(function() {
                        $("body").removeClass("prevent-scroll");
                        $("#popup_feature_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
                    }, 800);
                }, 1500);

                $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
                $("body").addClass("grade_body");
            }, 1200);
        }, 1000);
    }

    function close_feature_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_feature_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-utility").offset().top - 0
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_feature_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            $("#popup_feature_popup_all .header_grade_detail").removeClass("animated_header header_grade_detail_pos");
        }, 800);

        setTimeout(function() {
            $("#popup_feature_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_feature_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_feature_popup();
    });

    $(".utility-section").on("click", ".btn_feature_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_feature_popup($(this).data("tab-id"), _index);
    });
    // });
    var ii = 0;

    //show-hide popup_highlight
    // $(function() {
    function show_highlight_popup(index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_highlight_fade_all").fadeIn(780);

        $("#popup_highlight_popup_all").css("visibility", "hidden");
        $("#popup_highlight_popup_all").scrollTop(0);

        //--------------------//
        $("#popup_highlight_popup_all").addClass("active");
        initMainHeading("#popup_highlight_popup_all .main-heading");
        $("#popup_highlight_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");
        var offset_top = $("#popup_highlight_popup_all .popup_detail_holder > div")
            .eq(index)
            .offset().top;
        $("#popup_highlight_popup_all").css("visibility", "visible");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#popup_highlight_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // setTimeout(function () {
        //   $('body').removeClass('prevent-scroll');
        //   $('#popup_highlight_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        // },800);

        // $('body').removeClass('prevent-scroll');
        // $('#popup_highlight_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        // $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        // $('body').addClass('grade_body');

        // setTimeout(function () {
        //   $('#popup_highlight_popup_all').addClass('active');
        //   initMainHeading('#popup_highlight_popup_all .main-heading');
        //   $('#popup_highlight_popup_all .header_grade_detail').addClass('animated_header');
        //   $('body').addClass('prevent-scroll');

        //   var offset_top = $("#popup_highlight_popup_all .popup_detail_holder > div").eq(index).offset().top;
        //   // $("#popup_highlight_popup_all").scrollTop( offset_top - 95 );
        //   $("#popup_highlight_popup_all").css('visibility','visible');

        //   setTimeout(function () {
        //       // $('#popup_highlight_popup_all .header_grade_detail').addClass('animated_header');
        //       setTimeout(function () {
        //           $('#popup_highlight_popup_all').addClass('active_pos');

        //           setTimeout(function () {
        //             $('body').removeClass('prevent-scroll');
        //             $('#popup_highlight_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //           },800);

        //       }, 1500);

        //       $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        //       $('body').addClass('grade_body');
        //   }, 1200);

        // }, 1000);
    }

    // $(".grade_detail_popup_highlight").one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd',
    // function() {
    // });

    // $('.grade_detail_popup_highlight').on('transitionend MSTransitionEnd webkitTransitionEnd oTransitionEnd', function(event) {
    //   ii++;
    // });

    function close_highlight_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_highlight_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-hilight").offset().top - 56
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_highlight_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            // $('#popup_highlight_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
            $("#popup_highlight_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
        }, 800);

        setTimeout(function() {
            $("#popup_highlight_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_highlight_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_highlight_popup();
    });

    $(".hilight").on("click", ".btn_highlight_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_highlight_popup(_index);
    });

    // });

    //show-hide popup_safety
    // $(function() {
    function show_safety_popup(index) {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#popup_safety_fade_all").fadeIn(780);

        $("#popup_safety_popup_all").css("visibility", "hidden");
        $("#popup_safety_popup_all").scrollTop(0);

        $("#popup_safety_popup_all").addClass("active");
        initMainHeading("#popup_safety_popup_all .main-heading");
        $("#popup_safety_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");
        var offset_top = $("#popup_safety_popup_all .popup_detail_holder > div")
            .eq(index)
            .offset().top;
        $("#popup_safety_popup_all").css("visibility", "visible");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        $("#popup_safety_popup_all").addClass("active_pos");

        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#popup_safety_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // setTimeout(function () {
        // $('#popup_safety_popup_all').addClass('active');
        // initMainHeading('#popup_safety_popup_all .main-heading');
        // $('#popup_safety_popup_all .header_grade_detail').addClass('animated_header');
        // $('body').addClass('prevent-scroll');

        // var offset_top = $("#popup_safety_popup_all .popup_detail_holder > div").eq(index).offset().top;
        // $("#popup_safety_popup_all").scrollTop( offset_top - 95 );
        // $("#popup_safety_popup_all").css('visibility','visible');

        // setTimeout(function () {
        //     $('#popup_safety_popup_all .header_grade_detail').addClass('animated_header');

        // setTimeout(function () {
        //     $('#popup_safety_popup_all').addClass('active_pos');

        //     setTimeout(function () {
        //       $('body').removeClass('prevent-scroll');
        //       $('#popup_safety_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //     },800);

        // }, 1500);

        //     $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        //     $('body').addClass('grade_body');
        // }, 1200);

        // }, 1000);
    }

    function close_safety_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#popup_safety_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-safety").offset().top - 56
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#popup_safety_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            $("#popup_safety_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
            // $('#popup_safety_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
        }, 800);

        setTimeout(function() {
            $("#popup_safety_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#popup_safety_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_safety_popup();
    });

    $(".safety-section").on("click", ".btn_safety_pop_show", function(e) {
        e.preventDefault();
        var _index = $(this).data("index");
        show_safety_popup(_index);
    });

    // });

    //show-hide bodycolour popup
    // $(function() {
    function show_bodycolour_popup() {
        $(".sub-menu").addClass("sub-menu-hide");
        $("header:not(.header_grade_detail)").hide();
        $("#bodycolour_fade_all").fadeIn(780);

        $("#bodycolour_popup_all").addClass("active");
        initMainHeading("#popup_bodycolour_popup_all .main-heading");
        $("#bodycolour_popup_all .header_grade_detail").addClass("animated_header");
        $("body").addClass("prevent-scroll");

        $("#model-detail, #guideline, footer, .back-to-top-mb").hide();
        $("body").addClass("grade_body");

        $("#bodycolour_popup_all").addClass("active_pos");

        setTimeout(function() {
            $("body").removeClass("prevent-scroll");
            $("#bodycolour_popup_all .header_grade_detail").addClass("header_grade_detail_pos");
        }, 1000);

        // $('.sub-menu').addClass('sub-menu-hide');
        // $('header:not(.header_grade_detail)').hide();
        // $('#bodycolour_fade_all').fadeIn(780);

        // setTimeout(function () {
        //   $('#bodycolour_popup_all').addClass('active');
        //   initMainHeading('#popup_bodycolour_popup_all .main-heading');
        //   $('#bodycolour_popup_all .header_grade_detail').addClass('animated_header');
        //   $('body').addClass('prevent-scroll');

        // setTimeout(function () {
        // setTimeout(function () {
        //     $('#bodycolour_popup_all').addClass('active_pos');

        //     setTimeout(function () {
        //       $('body').removeClass('prevent-scroll');
        //       $('#bodycolour_popup_all .header_grade_detail').addClass('header_grade_detail_pos');
        //     },800);

        // }, 1500);

        //     $('#model-detail, #guideline, footer, .back-to-top-mb').hide();
        //     $('body').addClass('grade_body');
        // }, 1200);

        // }, 1000);
    }

    function close_bodycolour_popup() {
        $("header:not(.header_grade_detail), #model-detail, #guideline, footer, .back-to-top-mb").show();
        $("#bodycolour_popup_all").addClass("active_pos_fixed");

        setTimeout(function() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#nav-body-colour").offset().top - 0
                },
                0
            );
        }, 800);

        setTimeout(function() {
            $("#bodycolour_popup_all").removeClass("active active_pos active_pos_fixed");
            $("body").removeClass("grade_body");
            $(".sub-menu").removeClass("sub-menu-hide");
            $("#bodycolour_popup_all .header_grade_detail").removeClass("header_grade_detail_pos");
            // $('#bodycolour_popup_all .header_grade_detail').removeClass('animated_header header_grade_detail_pos');
        }, 800);

        setTimeout(function() {
            $("#bodycolour_fade_all").fadeOut(780);
        }, 1500);
    }

    $("#bodycolour_popup_all .btn_grade_pop_close").click(function(e) {
        e.preventDefault();
        close_bodycolour_popup();
    });

    $(".btn_bodycolour_pop_show").click(function(e) {
        e.preventDefault();
        show_bodycolour_popup();
    });
});



// WEBPACK FOOTER //
// ./resources/js/model-detail.js